import { StoreState } from 'store/reducers';

export const selectAuth = (state: StoreState) => state.auth;
export const selectErrors = (state: StoreState) => state.errors;
export const selectLoaders = (state: StoreState) => state.loaders;
export const selectLanding = (state: StoreState) => state.landing;
export const selectBooking = (state: StoreState) => state.booking;
export const selectProducts = (state: StoreState) => state.products;
export const selectShoppingBag = (state: StoreState) => state.shoppingBag;
